import { FirestoreDataConverter } from "@angular/fire/firestore";
import { SubcontractRequestState } from "../enums/subcontract-request-state.enum";
import { ProductPrice } from "./product-order.model";

export class SubcontractRequest {
  id: string;
  organizationId: string;
  // Subcontractor id
  subcontractorId: string;
  subcontractorEmails: string[];
  // External production id
  externalProductionId: string;
  // State
  state: SubcontractRequestState;
  // Comment
  comment: string;
  // Proposed prices
  prices: Record<string, ProductPrice[]>;

  constructor(request?: Partial<SubcontractRequest>) {
    this.id = request?.id ?? '';
    this.organizationId = request?.organizationId ?? '';
    this.subcontractorId = request?.subcontractorId ?? '';
    this.subcontractorEmails = request?.subcontractorEmails ?? [];
    this.externalProductionId = request?.externalProductionId ?? '';
    this.state = request?.state ?? SubcontractRequestState.NEW;
    this.comment = request?.comment ?? '';
    this.prices = request?.prices ?? {}
  }

  /**
   * Converter used to convert object from firebase
   */
  static converter: FirestoreDataConverter<SubcontractRequest> = {
    toFirestore: (request: SubcontractRequest) => ({
      id: request.id,
      organizationId: request.organizationId,
      subcontractorId: request.subcontractorId,
      subcontractorEmails: request.subcontractorEmails,
      externalProductionId: request.externalProductionId,
      state: request.state,
      comment: request.comment,
      prices: request.prices,
    }),
    fromFirestore: (snapshot, options) => {
      const data = snapshot.data(options);
      return new SubcontractRequest({ ...data, id: snapshot.id, subcontractorEmails: data['subcontractorEmails'] ?? [] });
    }
  };
}
